module.exports = __webpack_public_path__ + "static/media/feature.aaac83a3.jpeg";